/* eslint-disable radix */
/* eslint-disable no-restricted-syntax */
import history from '../../history'
import { getUrlSearchParams } from 'utils/urlParser'

export const getFiltersFromUrl = (params) => ({
  endDate: params.get('endDate') || null,
  initDate: params.get('initDate') || null,
  pendingTypeId: params.get('pendingTypeId')
    ? parseInt(params.get('pendingTypeId'))
    : null,
  reporterType: params.get('reporterType') || null,
  status: params.get('status') || null,
  targetType: params.get('targetType') || 'TRANSPORTER',
  notViewed: Boolean(params.get('notViewed')) || null,
  text: params.get('text') || null,
  externalId: params.get('externalId') || null,
})

export const getUrlFromFilters = (filters) => {
  const searchParams = new URLSearchParams()
  for (const key in filters) {
    if (Object.prototype.hasOwnProperty.call(filters, key)) {
      if (key === 'transporterId') {
        if (filters[key] !== null && filters[key] !== undefined) {
          searchParams.append('t', filters[key])
        }
      } else if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        searchParams.set(key, filters[key])
      }
    }
  }

  return `?${searchParams.toString()}`
}

export const REPORT_TYPES = [
  { value: 'SYSTEM', label: 'Sistema' },
  { value: 'TRANSPORTER', label: 'Transportador' },
  { value: 'DRIVER', label: 'Motorista' },
]

export const REPORT_MAP = {
  TRANSPORTER: 'Transportador',
  SYSTEM: 'Sistema',
  DRIVER: 'Motorista',
}

export const PENDENCIES_STATUS = [
  { label: 'Resolvida', value: 'RESOLVED' },
  { label: 'Aberta', value: 'OPEN' },
  { label: 'Cancelada', value: 'CANCELED' },
]

export const PENDENCY_STATUS_COLORS = {
  OPEN: '#f2c94c',
  RESOLVED: '#219653',
  DISPOSED: '#828282',
}

export const getPayload = () => {
  const { search } = history.location
  const query = getUrlSearchParams(search)
  return getFiltersFromUrl(query)
}


export const generateDeadlineByExpiration = (deadlineInDays) => {
  if (isNaN(deadlineInDays) || deadlineInDays === null) {
    return 'Vencimento inválido'
  }
  let textToShow = ''

  if (deadlineInDays === 0) {
    textToShow = 'Aberto'
  } else if (deadlineInDays && deadlineInDays < 0) {
    const daysAgo = Math.abs(deadlineInDays)
    textToShow = `Atrasado há ${daysAgo === 1 ? '1 dia' : `${daysAgo} dias`}`
  } else {
    textToShow = `${deadlineInDays} ${
      deadlineInDays === 1 ? 'dia' : 'dias'
    }`
  }

  return textToShow
}

export const pendingSize = 10

export const pendingsDateLabel = {
  OPEN: 'Prazo para resolução',
  RESOLVED: 'Data da resolução',
  DISPOSED: 'Data do descarte',
}

export const confirmationModalState = {
  visible: false,
  selectedPending: null,
  theme: 'purple',
  observation: '',
}
